import { useRef, useEffect } from "react";
import { useTealiumEventProperties, useDispatchTrackPageView, useDispatchTrackEvent } from "@grandvisionhq/svc-tealium/events";
const useAccountLoginTracking = ({ queryLoginMethod, type }) => {
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const hasTrackedRef = useRef(false);
  const dispatchTrackPageView = useDispatchTrackPageView();
  const dispatchTrackEvent = useDispatchTrackEvent();
  useEffect(() => {
    const trackEvents = async () => {
      try {
        if (hasTrackedRef.current) return;
        const commonUserProperties = await getCommonUserProperties();
        if (!commonUserProperties) return;
        const loginPageView = () => Promise.resolve({
          id: "VirtualPage-View",
          Page_Section1: "Account",
          Page_Type: "Static",
          Page_Design: "Login",
          ...commonEventProperties,
          ...commonUserProperties
        });
        const loginEvent = () => Promise.resolve({
          id: "Event",
          Events_UserLogin: "1",
          ...commonUserProperties
        });
        if (queryLoginMethod === "social" || type === "callback") {
          await dispatchTrackEvent(loginEvent);
          await dispatchTrackPageView(loginPageView);
        }
        hasTrackedRef.current = true;
      } catch (error) {
        console.error("Tealium tracking failed:", error);
      }
    };
    trackEvents();
  }, [commonEventProperties, queryLoginMethod, getCommonUserProperties, type]);
};
export {
  useAccountLoginTracking
};
//# sourceMappingURL=use-account-login-tracking.js.map
